import { axiosOtherTrackerInstance } from "../../configs/AxiosInstance";

/* Fetch User Target Plan Sleep */
export const fetchUserTargetPlanSleep = async (get, eventTypeId, clientId) => {
  try {
    const response = await get(
      `/fetch-user-target-plan-sleep?event_type_id=${eventTypeId}&client_id=${clientId}`,
      {
        instance: axiosOtherTrackerInstance,
      }
    );

    if (response && response.target_plan_sleep) {
      return {
        success: true,
        data: {
          created: response.target_plan_sleep.created || [],
          assigned: response.target_plan_sleep.assigned || [],
          both: response.target_plan_sleep.both || [],
        },
      };
    }

    return {
      success: false,
      message: "Target plan sleep data not found",
    };
  } catch (error) {
    console.error("Error fetching user target plan sleep:", error);
    return {
      success: false,
      message: "Error fetching user target plan sleep",
    };
  }
};
